<div class="check-box" [class.check-box--checked]="checked">
    <i class="check-box__icon fas fa-check"></i>
</div>
